import './PaginatedList.scss';
import classNames from 'classnames';
import { GenericList } from './GenericList';
import { KeyPagination } from '@ui/KeyPagination';
import { UpdateQueryParams } from '@hooks';
import { KeyPaginationQueryParams, PaginatedResource } from '@sonar-software/sonar-ts-types';
import React, { useRef } from 'react';

const defaultListClassName = 'paginated-list';
const defaultPaginatorClassName = 'list-paginator';

export interface PaginatedListProps<T> {
	empty?: React.ReactNode;
	listClassName?: string;
	loading: boolean;
	onChange: UpdateQueryParams<KeyPaginationQueryParams>;
	paginatorClassName?: string;
	queryParams: KeyPaginationQueryParams;
	renderListItem: (item: T, index: number) => JSX.Element;
	resource: PaginatedResource<T> | null | undefined;
}

export function PaginatedList<T>({
	empty,
	listClassName,
	loading,
	onChange,
	queryParams,
	paginatorClassName,
	renderListItem,
	resource
}: PaginatedListProps<T>): JSX.Element {
	const scrollableListRef = useRef<HTMLDivElement>(null);

	return (
		<>
			<GenericList
				className={ classNames(defaultListClassName, listClassName) }
				empty={ empty }
				items={ resource?.results ?? [] }
				loading={ loading }
				ref={ scrollableListRef }
				renderItem={ renderListItem } />
			<KeyPagination
				autoHide
				className={ classNames(defaultPaginatorClassName, paginatorClassName) }
				defaultPageSize={ queryParams.count ?? 20 }
				listRef={ scrollableListRef }
				onChange={ onChange }
				resource={ resource } />
		</>
	);
}
